import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import {
  fgtnQrBarFontSize,
  fgtnQrBarHeight,
  fitQrBarFontSize,
  shareQrSupportFontSize,
  shareQrUrlFontSize,
} from '../../utils/fgtnQrCard';

export default function FgtnQrArt({
  episodeNumber,
  url,
  size,
  title,
  headline,
  caption,
  supportingText,
  displayUrl,
  extraLines,
  barColor,
  bottomBarColor,
  variant = 'default',
}) {
  const heading = headline || `FGTN Episode ${episodeNumber}`;
  const bottomLines =
    Array.isArray(extraLines) && extraLines.length
      ? extraLines.filter(Boolean)
      : [supportingText, caption || (headline ? '' : 'Scan for links'), displayUrl].filter(Boolean);
  const topBarHeight = fgtnQrBarHeight(size, 0, variant);
  const bottomBarHeight = fgtnQrBarHeight(size, bottomLines.length, variant);
  const headingSize = fitQrBarFontSize(size, heading, variant);
  const fontSize = fgtnQrBarFontSize(size, variant);
  const supportSize = shareQrSupportFontSize(size, variant);
  const stacked = bottomLines.length > 1;
  const headingWraps = variant === 'launch' || headingSize < fontSize;

  return (
    <div className={`fgtn-qr-art${variant === 'launch' ? ' is-launch' : ''}`} style={{ width: size }}>
      <div
        className={`fgtn-qr-art-bar${headingWraps ? ' is-stack' : ''}`}
        style={{
          minHeight: topBarHeight,
          height: headingWraps ? 'auto' : topBarHeight,
          fontSize: headingSize,
          ...(barColor ? { background: barColor } : {}),
        }}
      >
        {heading}
      </div>
      <div className="fgtn-qr-art-code" data-qr-destination={url}>
        <QRCodeSVG
          value={url}
          size={size}
          level="H"
          marginSize={2}
          bgColor="#ffffff"
          fgColor="#111111"
          title={title || `QR code for ${heading}`}
        />
      </div>
      <div
        className={`fgtn-qr-art-bar${stacked ? ' is-stack' : ''}`}
        style={{
          minHeight: bottomBarHeight,
          height: stacked ? 'auto' : bottomBarHeight,
          fontSize: stacked ? supportSize : fontSize,
          ...(bottomBarColor || barColor ? { background: bottomBarColor || barColor } : {}),
        }}
      >
        {stacked
          ? bottomLines.map((line) => {
              const isUrl = /at\.fish\//i.test(line);
              return (
                <span
                  key={line}
                  className={`fgtn-qr-art-line${isUrl ? ' is-url' : ''}`}
                  style={isUrl ? { fontSize: shareQrUrlFontSize(size, variant) } : undefined}
                >
                  {line}
                </span>
              );
            })
          : bottomLines[0]}
      </div>
    </div>
  );
}
